// eslint-disable-next-line no-shadow
export enum GenerationType {
	MUSIC_VIDEO = 'music_video',
	CLOTH_SWAP = 'cloth_swap',
	OBJECT_PLACEMENT = 'object_placement',
	VIDEO_ANYONE = 'video_anyone',
}
